import { api } from "./api";

const ManageSubscribersService = api.injectEndpoints({
    endpoints: (builder) => ({

        //saveJournal
       
        paginationManageSubscribers: builder.mutation({
            query: (data) => ({
                url: "subscription/getAllSubscriptionPagination",
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: data,
            }),
        }),
       
      
        
        
    }),
    overrideExisting: false,
});

export const {
   usePaginationManageSubscribersMutation
} = ManageSubscribersService;